/**
 * @file automatically generated from MApp.Endpoints.ServerController
 */

import { MetadataClient } from '../metadataClient';
import { ILatestVersion } from '../models';

export class ServerClient extends MetadataClient {

	public static getCurrentVersion() {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/server/currentversion`, {
				cache: 'no-cache'
			})
		);
	}

	public static getLatestVersion() {
		return MetadataClient.ajax<ILatestVersion>(
			new Request(MetadataClient.endpointsUrl + `api/v1/server/latestversion`, {
				cache: 'no-cache'
			})
		);
	}
}
